import { render, staticRenderFns } from "./intelligent-answers.vue?vue&type=template&id=ba9e453e&scoped=true&"
import script from "./intelligent-answers.vue?vue&type=script&lang=js&"
export * from "./intelligent-answers.vue?vue&type=script&lang=js&"
import style0 from "./intelligent-answers.vue?vue&type=style&index=0&id=ba9e453e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9e453e",
  null
  
)

export default component.exports